import { render, staticRenderFns } from "./ExternalPlanAuth.vue?vue&type=template&id=4602f98a"
import script from "./ExternalPlanAuth.vue?vue&type=script&lang=js"
export * from "./ExternalPlanAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports